export default function ScopeSummary({
  usersInScope = 0,
  usersWithActivity = 0,
  periodPhrase = "in this period",
}) {
  const inScope = Math.max(0, Number(usersInScope) || 0);
  const withActivity = Math.min(inScope, Math.max(0, Number(usersWithActivity) || 0));
  const withoutActivity = Math.max(0, inScope - withActivity);
  const ratio = inScope ? withActivity / inScope : 0;
  const noun = inScope === 1 ? "signed-in user" : "signed-in users";

  return (
    <section className="pa-coverage" aria-label="Scope summary">
      <p className="pa-coverage__label">Scope summary</p>
      <p className="pa-coverage__copy">
        {inScope} {noun} · {withActivity} with activity {periodPhrase}
      </p>
      <div className="pa-coverage__bar" aria-hidden="true">
        <span className="pa-coverage__fill" style={{ width: `${Math.round(ratio * 100)}%` }} />
      </div>
      <div className="pa-scope-stats">
        <p>
          <strong>{inScope}</strong>
          <span>Signed in</span>
        </p>
        <p className="pa-scope-stats--activity">
          <strong>{withActivity}</strong>
          <span>With activity</span>
        </p>
        <p className="pa-scope-stats--none">
          <strong>{withoutActivity}</strong>
          <span>No activity</span>
        </p>
      </div>
    </section>
  );
}
